import { render, staticRenderFns } from "./TxCos.vue?vue&type=template&id=50f6db63&scoped=true&"
import script from "./TxCos.vue?vue&type=script&lang=js&"
export * from "./TxCos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f6db63",
  null
  
)

export default component.exports